import React from 'react';
import styled from 'styled-components';
import { minBp } from 'src/lib/theme';

export const Overlay = styled.div`
  ${({ open, disableFullScreen, isMessage }) => `
    display: ${isMessage ? 'block' : 'none'};

    ${
      isMessage
        ? `
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0,0,0,0.5);
      z-index: 999;
    `
        : ``
    }
    
    @media ${minBp(disableFullScreen ? 'tablet' : 'tabletLarge')} {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 999;
      opacity: 0;
      background-color: rgba(0, 0, 0, 0.5);
      transition: opacity 0.2s ease-in;
      display: block;

      ${
        open
          ? `
              opacity: 1;
            `
          : null
      }
    }
  `}
`;

export const Wrap = styled.div`
  ${({ isFullScreen, disableFullScreen, isMessage }) => `
    display: inline-block;
    height: 100%;
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1000;
    background: #fff;
    overflow: scroll;
    
    @media ${minBp(disableFullScreen ? 'tablet' : 'tabletLarge')} {
      box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.5);
      transform: translate(-50%, -50%);
      top: 50%;
      left: 50%;
      width: ${isFullScreen ? '100%' : 'auto'};
      height: ${isFullScreen ? '100%' : 'auto'};
      overflow: ${isFullScreen ? 'hidden' : 'auto'};
    }

    ${
      isMessage
        ? `
      transform: translate(-50%, -50%);
      top: 50%;
      left: 50%;
      width: 400px;
      height: ${isFullScreen ? '100%' : 'auto'};
      overflow: ${isFullScreen ? 'hidden' : 'auto'};
      max-width: 90%;
      border-radius: 4px;
    `
        : ``
    }
  `}
`;

const closeThemeFormatter = crossTheme =>
  Object.keys(crossTheme)
    .filter(breakpoint => breakpoint !== 'base')
    .reduce((previousCss, breakpoint) => {
      previousCss += `
    @media ${minBp(breakpoint)} {
      path {
        fill: ${crossTheme[breakpoint] === 'light' ? 'black' : 'white'};
      }
    }
  `;

      return previousCss;
    }, '');

export const CloseIcon = styled.button`
  appearance: none;
  background: none;
  border: none;
  position: absolute;
  top: 10px;
  right: 15px;
  cursor: pointer;
  padding: 10px;

  ${({ isMessage }) =>
    isMessage
      ? `
    right: 10px;
  `
      : ``}

  @media ${minBp('tabletLarge')} {
    top: 20px;
    right: 20px;
  }

  svg {
    pointer-events: none;
    display: block;
    width: 22px;
    height: 22px;

    @media ${minBp('tabletLarge')} {
      width: 24px;
      height: 24px;
    }

    path {
      fill: ${({ crossTheme }) => (crossTheme.base === 'light' ? 'black' : 'white')};
    }

    ${({ crossTheme }) => closeThemeFormatter(crossTheme)}
  }
`;

export const Dialog = styled.div`
  ${({ theme, isFullScreen, disableFullScreen }) => `
    background-color: white;
    z-index: 1000;
    height: 100%;

    ${CloseIcon} {
      z-index: 1001;
    }
    
    @media ${minBp(disableFullScreen ? 'tablet' : 'tabletLarge')} {
      animation-name: fadeIn;
      animation-duration: 0.6s;
      animation-fill-mode: forwards;
      will-change: opacity;
      height: ${isFullScreen ? '100%' : 'auto'};
      opacity: 0;
  
      @keyframes fadeIn {
        from {
          opacity: 0;
        }
  
        to {
          opacity: 1;
        }
      }

      ${CloseIcon} {
        top: ${isFullScreen && '10px'} 
        right: ${isFullScreen && '40px'} 
      }
    }

    @media ${minBp('desktop')} { 
      ${CloseIcon} {
        top: ${isFullScreen && '54px'} 
      }
    }
  `}
`;
